export default __webpack_public_path__ + "media/images/brands/wedgwood-eb171662a07ed9feb673094fb063d49b.png";